import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot} from '@angular/router';
import {AuthService} from '../service/auth.service';
import {UrlHelper} from './url.helper';

@Injectable({providedIn: 'root'})
export class AuthGuard implements CanActivate {
  constructor(private router: Router, private authService: AuthService) {
  }

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const session = await this.authService.getSession();
    if (session && session.isValid()) {
      // logged in so return true
      return true;
    }

    // not logged in so redirect to signIn page with the return url
    await this.router.navigate([UrlHelper.SIGN_IN_PATH], {queryParams: {returnUrl: state.url}});

    return false;
  }
}
